import { DeleteModal } from 'common-front/src/designSystem/components/deleteModal';
import { Role } from 'common/src/generated/types';
import { useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { useRoleDeleteMutation } from '../../../../generated/graphqlHooks';
import { RoleUses } from './roleUses';

export const DeleteRoleModal = ({
    onClose,
    onDelete,
    role
}: {
    onClose: React.ComponentProps<typeof DeleteModal>['onClose'];
    onDelete: () => void;
    role: Pick<Role, 'id' | 'name'>;
}) => {
    const translate = useTranslate();
    const { organizationId } = useParams();
    const { mutate } = useRoleDeleteMutation();

    return (
        <DeleteModal
            buttonText={translate('supprimer_43083')}
            text={translate('suppression_de_73669', role.name)}
            onClose={onClose}
            onDelete={() =>
                mutate({ organizationId, roleId: role.id }).then((result) => {
                    onDelete();

                    return result;
                })
            }
        >
            <RoleUses role={role} />
        </DeleteModal>
    );
};
